module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_kitchen.56a59ef3.png";